import { apiFetch, type RequestAuth } from './client';

/**
 * One row on the read-only Installations tab. Inaccessible rows have null
 * instanceName/organization and a masked trackerId (`***xx`); `accessible`
 * flags which.
 */
export interface AppInstallationItem {
  instanceName: string | null;
  organization: string | null;
  /** shard id the install was fetched from, e.g. "us" / "eu" / "au". */
  region: string;
  /** install created-at timestamp (ISO). */
  installedAt: string;
  version: string;
  /** install last-updated timestamp (ISO). */
  lastUpdated: string;
  /** full when accessible, `***` + last 2 chars when inaccessible. */
  trackerId: string;
  /** "CMS" for a per-instance install, null for account-level; set even on inaccessible rows. */
  installationScopeType: string | null;
  /**
   * Turnstile UUID of the CMS instance a per-instance install is scoped to; null for an
   * account-level install and whenever the caller lacks access to that CMS instance.
   */
  scope: string | null;
  /** display name of that CMS instance; null when unscoped or the lookup failed. */
  scopeName: string | null;
  accessible: boolean;
}

/** rivendell `GET /dev-portal/apps/{appId}/installations`. */
export interface AppInstallationsResponse {
  items: AppInstallationItem[];
  degradedShards: string[];
}

export function getAppInstallations(
  auth: RequestAuth,
  appId: string,
): Promise<AppInstallationsResponse> {
  return apiFetch<AppInstallationsResponse>(
    `/dev-portal/apps/${encodeURIComponent(appId)}/installations`,
    auth,
  );
}
